import { useState } from "react";
import { SHOTS } from "./data";
import { Section, BrowserFrame } from "./ui";

export const Showcase = () => {
  const [cur, setCur] = useState(SHOTS[0].key);
  const s = SHOTS.find((x) => x.key === cur);
  return (
    <Section id="captures" over="EN IMAGES" title="L'application, telle que vous l'utiliserez" lead="Captures réelles de ScreenView, avec un parc de démonstration.">
      <div className="flex flex-wrap gap-2 mb-8">
        {SHOTS.map((x) => (
          <button key={x.key} onClick={() => setCur(x.key)} data-testid={`showcase-tab-${x.key}`}
            className={`px-4 py-2 rounded-full text-sm border transition-colors ${cur === x.key ? "border-sky-400 text-white bg-sky-500/15" : "border-slate-800 text-slate-400 hover:text-white hover:border-slate-600"}`}>
            {x.label}
          </button>
        ))}
      </div>
      <div key={cur} className="grid lg:grid-cols-[1fr_300px] gap-8 items-start fade-up" data-testid={`showcase-panel-${cur}`}>
        <BrowserFrame src={s.src} alt={s.label} />
        <div className="lg:pt-6">
          <h3 className="text-xl font-bold mb-3">{s.label}</h3>
          <p className="text-slate-400 leading-relaxed">{s.text}</p>
        </div>
      </div>
    </Section>
  );
};
